import React, { useState, useEffect } from 'react';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import { Divider } from 'primereact/divider';
import { Dropdown } from "primereact/dropdown";

import useAxiosPrivate from "../hooks/useAxiosPrivate";

const EstadoCuenta = () => {
    const [alumnos, setAlumnos] = useState([]);
    const [alumno, setAlumno] = useState(null);

  const [matricula, setMatricula] = useState('');
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
const axiosPrivate = useAxiosPrivate();

useEffect(() => {
    const loadAlumnos = async () => {
      try {
        const res = await axiosPrivate.get("CEUM/alumnos/listado");
        setAlumnos(res.data);
      } catch (e) {
        console.error(e);
      }
    };
    loadAlumnos();
  }, []);

  const buscar = async (matricula) => {
    if (!matricula) return;
    setLoading(true);
    try {
      const res = await axiosPrivate.get(`CEUM/estado-cuenta/${matricula}`);
      setData(res.data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const money = (v) => `$ ${Number(v || 0).toFixed(2)}`;

  const statusTemplate = (row) => {
    const map = {
      pagado: 'success',
      pendiente: 'warning',
      vencido: 'danger'
    };
    return <Tag value={row.estatus} severity={map[row.estatus] || 'info'} />;
  };
  useEffect(() => {
    if (alumno?.Matricula) {
      buscar(alumno.Matricula);
    }
  }, [alumno]);
  return (
    <Card className="p-4" title='Estado de Cuenta'>

      {/* 🔍 Buscador */}
      <div className="flex gap-2 mb-4">
        <Dropdown
                  value={alumno}
                  options={alumnos}
                  onChange={(e) => {
                    setAlumno(e.value);
                    if (!e.value) {
                      setData(null);
                    }
                  }}
                  optionLabel="nombre_completo"
                  placeholder="Selecciona alumno"
                  filter
                  showClear
                />
        {/* <InputText
          value={matricula}
          onChange={(e) => setMatricula(e.target.value)}
          placeholder="Matrícula"
        />
        <Button label="Buscar" icon="pi pi-search" onClick={buscar} loading={loading} /> */}
      </div>

      {data && (
        <>
          {/* 📊 RESUMEN */}
          <div className="grid">
            <div className="col-12 md:col-4">
              <Card title="Total Cargos">
                <h2>{money(data.resumen.total_cargos)}</h2>
              </Card>
            </div>
            <div className="col-12 md:col-4">
              <Card title="Total Pagado">
                <h2>{money(data.resumen.total_pagado)}</h2>
              </Card>
            </div>
            <div className="col-12 md:col-4">
              <Card title="Saldo Pendiente">
                <h2>{money(data.resumen.total_saldo)}</h2>
              </Card>
            </div>
          </div>

          <Divider />

          {/* 📋 CARGOS */}
          <h3>Cargos</h3>
          <DataTable value={data.cargos} paginator rows={10} className="p-datatable-sm">
            <Column field="concepto" header="Concepto" />
            <Column field="periodo" header="Periodo" />
            <Column field="fecha_vencimiento" header="Vencimiento" />
            <Column header="Monto" body={(r) => money(r.monto)} />
            <Column header="Saldo" body={(r) => money(r.saldo)} />
            <Column header="Estatus" body={statusTemplate} />
          </DataTable>

          <Divider />

          {/* 💳 PAGOS */}
          <h3>Pagos</h3>
          <DataTable value={data.pagos} paginator rows={5} className="p-datatable-sm">
            <Column field="fecha" header="Fecha" />
            <Column field="metodo_pago" header="Método" />
            <Column header="Total" body={(r) => money(r.total)} />
          </DataTable>
        </>
      )}

    </Card>
  );
};

export default EstadoCuenta;
